import React from 'react';

const LatestworkItem = (props) => {
    const alt = props.title
        ? `${props.title} — proyecto desarrollado por Coralan Multiservice`
        : 'Proyecto desarrollado por Coralan Multiservice';
    return (
        <div className={`${props.category} col-sm-6 col-md-3 mb-2`} data-reveal="zoom" data-reveal-delay={String(((props.index || 0) % 4) + 1)}>
            <div className="filter-img-block position-relative image-container translate-effect-right lift">
                <a href={props.url} target="_blank" rel="noopener noreferrer" aria-label={alt}>
                    <img src={props.image} alt={alt} className="w-100" loading="lazy" />
                </a>
            </div>
        </div>
    );
};

export default LatestworkItem;
